// Batch 4: Alexandria, Delta, Canal, Coastal & Upper Egypt (47 Areas)
export const areaContentBatch4 = {
  "الإسكندرية": {
    tier: 1,
    title: "ونش انقاذ الإسكندرية",
    metaDescription: "ونش انقاذ الإسكندرية: كورنيش الإسكندرية، سموحة، ميامي، المنتزه، محطة الرمل، كوبري ستانلي، العجمي. وصول 15-20 دقيقة خدمة 24/7 بخصم 50% - 01044844492.",
    intro: "عروس البحر الأبيض المتوسط ومقر أسطولنا في الساحل الشمالي. أوناش إنقاذ محمد بحر متمركزة في سموحة وميامي وكورنيش الإسكندرية ومحطة الرمل وبوابات الطريق الصحراوي والزراعي لإنقاذ وسحب سيارات الملاكي والنقل على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة في الإسكندرية",
    landmarks: ["مكتبة الإسكندرية", "قلعة قايتباي", "كوبري ستانلي الشهير", "ميدان محطة الرمل", "جرين بلازا سموحة", "حدائق وقصر المنتزه", "نادي سبورتنج السكندري"],
    streets: ["طريق الجيش (كورنيش الإسكندرية)", "طريق الحرية (شارع أبو قير)", "شارع فؤاد التراثي", "شارع بورسعيد الإسكندرية", "شارع مصطفى كامل سموحة", "طريق الإسكندرية الصحراوي", "طريق الإسكندرية الزراعي"],
    localNotes: ["أوناش سطحة هيدروليكية كاملة مجهزة للتعامل مع أعطال الكورنيش والتقلبات الجوية والنوات الشتوية.", "تغطية فورية لحوادث وأعطال طريق الكورنيش وشارع أبو قير وشارع جمال عبد الناصر."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في سموحة أو كورنيش الإسكندرية؟",
            "a": "من 15 إلى 20 دقيقة لتمركز أوناشنا المباشر في ميادين سموحة ومحطة الرمل وميامي."
      }
,
      {
        "q": "ما أسرع خدمة إنقاذ متاحة في الإسكندرية المدينة؟",
        "a": "خدمة السحب والإنقاذ السريعة في الإسكندرية تصلك في 20-35 دقيقة. للحوادث خارج المدينة قد يصل الزمن لـ 45 دقيقة."
      }],
    nearby: ["سموحة", "كورنيش الإسكندرية", "ميامي", "المنتزه", "محطة الرمل", "العجمي", "الساحل الشمالي"]
  },

  "سموحة": {
    tier: 1,
    title: "ونش انقاذ سموحة الإسكندرية",
    metaDescription: "ونش انقاذ سموحة: جرين بلازا، ميدان فيكتور عمانويل، نادي سموحة، كوبري 14 مايو، شارع فوزي معاذ. وصول 10-15 دقيقة - 01044844492.",
    intro: "حي سموحة المركز التجاري والسكني الأرقى في الإسكندرية. نوفر أوناش إنقاذ متمركزة عند ميدان فيكتور عمانويل ومول جرين بلازا ونادي سموحة الرياضي لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة في سموحة",
    landmarks: ["مول جرين بلازا Green Plaza", "نادي سموحة الرياضي", "ميدان فيكتور عمانويل", "مستشفى سموحة الدولي", "محطة قطار سيدي جابر (بالقرب)", "كوبري 14 مايو"],
    streets: ["شارع فوزي معاذ", "شارع ألبرت الأول", "شارع مصطفى كامل", "طريق 14 مايو", "شارع زكي رجب", "شارع النصر سموحة"],
    localNotes: ["أوناش هيدروليكية منخفضة قادرة على دخول جراجات جرين بلازا وعمارات سموحة السكنية.", "انطلاق سريع نحو الطريق الزراعي أو الكورنيش عبر كوبري 14 مايو ومحور المحمودية."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند جرين بلازا أو نادي سموحة؟",
            "a": "نعم، أوناشنا متواجدة بميدان فيكتور عمانويل وجرين بلازا على مدار 24 ساعة."
      }
,
      {
        "q": "ما هي المناطق المجاورة التي يمكنكم الوصول إليها من سموحة؟",
        "a": "من سموحة نصل لسيدي جابر والبيطاش والمنتزه وميامي والشاطبي في 10-25 دقيقة حسب المسافة."
      }],
    nearby: ["الإسكندرية", "سيدي جابر", "محرم بك", "الشاطبي", "طريق المطار السكندري"]
  },

  "كورنيش الإسكندرية": {
    tier: 1,
    title: "ونش انقاذ كورنيش الإسكندرية",
    metaDescription: "ونش انقاذ طريق الكورنيش بالإسكندرية: من قلعة قايتباي والأنفوشي حتى كوبري ستانلي، جليم، وميامي والمنتزه. وصول 10-15 دقيقة - 01044844492.",
    intro: "طريق كورنيش الإسكندرية (طريق الجيش) الواجهة الساحلية الأطول والأكثر حيوية. نوفر أوناش إنقاذ سريعة متمركزة على طول الكورنيش من بحري والأنفوشي حتى المنتزه والمعمورة لإنقاذ فوري للمركبات طوال 24 ساعة.",
    responseTime: "10–15 دقيقة على كورنيش الإسكندرية",
    landmarks: ["كوبري ستانلي الشهير", "مكتبة الإسكندرية بالشاطبي", "قلعة قايتباي بحري", "فندق هيلتون كورنيش الإسكندرية", "سان ستيفانو جراند بلازا", "بئر مسعود بميامي"],
    streets: ["طريق الجيش (الكورنيش)", "شارع 26 يوليو السكندري", "شارع الأنفوشي", "شارع الكازينو", "طريق المنتزه الساحلي"],
    localNotes: ["تأمين فوري للسيارات المتعطلة على طريق الكورنيش السريع لتفادي الحوادث في أوقات النوات والازدحام الصيفي.", "أوناش مجهزة بسلاسل ومثبتات قوية لمنع انزلاق السيارات في الأجواء الممطرة."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش عند كوبري ستانلي أو سان ستيفانو على الكورنيش؟",
            "a": "أقل من 10 دقائق لتواجد أوناشنا المستمر على طول طريق الجيش."
      }
,
      {
        "q": "هل تخدمون حوادث الأعطال على كورنيش الإسكندرية بكامل امتداده؟",
        "a": "نعم، كورنيش الإسكندرية من العجمي غرباً حتى المنتزه شرقاً — امتداد كامل بطول 25 كم مغطى 24/7."
      }],
    nearby: ["الإسكندرية", "ستانلي", "ميامي", "المنتزه", "الشاطبي", "محطة الرمل"]
  },

  "المنتزه": {
    tier: 2,
    title: "ونش انقاذ المنتزه الإسكندرية",
    metaDescription: "ونش انقاذ المنتزه: حدائق وقصر المنتزه، فندق فلسطين، كوبري المندرة، شارع ملك حفني، المعمورة. وصول 10-15 دقيقة - 01044844492.",
    intro: "حي المنتزه السياحي الراقي في أقصى شرق الإسكندرية. نوفر أوناش إنقاذ متمركزة عند بوابات قصر المنتزه ومحيط كوبري المندرة وشارع ملك حفني لخدمة المصطافين والنزلاء على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة في المنتزه",
    landmarks: ["حدائق وقصر المنتزه التاريخي", "فندق فلسطين المنتزه", "كوبري المندرة وكورنيش المندرة", "محطة قطار المنتزه", "شاطئ عايدة"],
    streets: ["شارع ملك حفني (بحري وقبلي)", "طريق الجيش (كورنيش المنتزه)", "شارع جمال عبد الناصر (المندرة)", "طريق الطابية"],
    localNotes: ["أوناش سطحة مجهزة لخدمة الفنادق والمنتجعات السياحية بمحيط المنتزه والمعمورة.", "توفير خدمات الطوارئ للبطاريات وتغيير الإطارات في الموقع."],
    faqs: [
      {
            "q": "هل تغطون بوابات حدائق قصر المنتزه وفندق فلسطين؟",
            "a": "نعم، أوناشنا متواجدة عند بوابات المنتزه والمندرة على مدار الساعة."
      }
,
      {
        "q": "ما أسرع طريق للوصول للمنتزه من وسط الإسكندرية؟",
        "a": "عبر الكورنيش أو الطريق الزراعي — نصل في 20-30 دقيقة. في الموسم الصيفي قد يصل الوقت لـ 45 دقيقة بسبب الزحام."
      }],
    nearby: ["المعمورة", "ميامي", "الإسكندرية", "أبو قير", "العصافرة"]
  },

  "المعمورة": {
    tier: 2,
    title: "ونش انقاذ المعمورة الشاطئ والبلد",
    metaDescription: "ونش انقاذ المعمورة: بوابات المعمورة الشاطئ، ملاهي المعمورة، طريق أبو قير، المعمورة البلد. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "منطقة المعمورة الشاطئ والمعمورة البلد شرق الإسكندرية. أوناش إنقاذ محمد بحر متواجدة عند بوابات المعمورة ومحطة القطار لتقديم خدمة سحب ورفع سيارات سريعة وآمنة للمصطافين والأهالي.",
    responseTime: "10–15 دقيقة في المعمورة",
    landmarks: ["بوابة المعمورة الشاطئ الرئيسية", "ملاهي المعمورة بارك", "محطة قطار المعمورة", "شاطئ المعمورة السياحي", "الأكاديمية العربية بأبي قير (بالقرب)"],
    streets: ["شارع النصر المعمورة", "طريق المعمورة الشاطئ", "طريق أبو قير السكندري", "شارع ملك حفني المعمورة"],
    localNotes: ["تنسيق سريع للدخول عبر بوابات المعمورة الشاطئ دون أي تعطيل للعميل.", "أوناش مدمجة تتحرك بسلاسة في شوارع المعمورة السكنية والمصيفية."],
    faqs: [
      {
            "q": "كيف يتم التنسيق لدخول ونش الإنقاذ داخل بوابات المعمورة الشاطئ؟",
            "a": "يقوم سائق الونش بإبراز تصريح المهمة والتنسيق مع أمن البوابة لسرعة الدخول."
      }
,
      {
        "q": "هل تغطون منطقة المعمورة والشاليهات المنتشرة على الطريق الساحلي؟",
        "a": "نعم، المعمورة والمعمورة الشاطئ وإدكو والطريق الزراعي مغطاة كاملاً في موسم الصيف والشتاء."
      }],
    nearby: ["المنتزه", "أبو قير", "ميامي", "الإسكندرية", "طريق رشيد"]
  },

  "الشاطبي": {
    tier: 2,
    title: "ونش انقاذ الشاطبي الإسكندرية",
    metaDescription: "ونش انقاذ الشاطبي: مكتبة الإسكندرية، مجمع كليات جامعة الإسكندرية، مستشفى الشاطبي، كوبري الجامعة. وصول 5-10 دقائق - 01044844492.",
    intro: "حي الشاطبي الصرح التعليمي والثقافي الأول بالإسكندرية. نوفر أوناش إنقاذ متمركزة أمام مكتبة الإسكندرية ومجمع الكليات النظرية ومستشفى الشاطبي للولادة والأطفال لإنقاذ سريع على مدار 24 ساعة.",
    responseTime: "5–10 دقائق في الشاطبي",
    landmarks: ["مكتبة الإسكندرية Bibliotheca Alexandrina", "مجمع كليات جامعة الإسكندرية بالشاطبي", "مستشفى الشاطبي الجامعي", "نادي الاتحاد السكندري بالشاطبي", "مسرح بيرم التونسي"],
    streets: ["طريق الجيش (كورنيش الشاطبي)", "طريق الحرية (شارع أبو قير)", "شارع بورسعيد الشاطبي", "شارع شامبليون السكندري", "شارع الدكتور مصطفى مشرفة"],
    localNotes: ["أوناش متواجدة بالقرب من مكتبة الإسكندرية لخدمة الطلاب والأساتذة والزوار.", "توفير خدمات وصلة البطارية وتزويد الوقود وسحب سيارات الطوارئ أمام المستشفيات."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام مكتبة الإسكندرية بالشاطبي؟",
            "a": "أقل من 10 دقائق لتواجد أوناشنا المباشر على كورنيش الشاطبي."
      }
,
      {
        "q": "هل تخدمون الجامعات والمستشفيات في حي الشاطبي؟",
        "a": "نعم، شاطبي والمحيط الجامعي وكلية الطب ومستشفى الشاطبي الجامعي مغطاة بأسطولنا."
      }],
    nearby: ["محطة الرمل", "الأزاريطة", "سيدي جابر", "سموحة", "الإسكندرية"]
  },

  "ميامي": {
    tier: 1,
    title: "ونش انقاذ ميامي الإسكندرية",
    metaDescription: "ونش انقاذ ميامي: شارع جمال عبد الناصر، شارع خالد بن الوليد، شارع العيسوي، كورنيش ميامي، بئر مسعود. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "ميامي أشهر أحياء الإسكندرية المصيفية والتجارية. أوناش إنقاذ محمد بحر متمركزة عند شارع خالد بن الوليد وجمال عبد الناصر وبئر مسعود على الكورنيش لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10 دقائق في ميامي",
    landmarks: ["شاطئ ميامي الشهير", "نصب وصخرة بئر مسعود", "شارع خالد بن الوليد التجاري", "الأكاديمية العربية للعلوم والتكنولوجيا (ميامي)", "مستشفى مبرة العصافرة"],
    streets: ["شارع جمال عبد الناصر (ميامي)", "شارع خالد بن الوليد", "طريق الجيش (كورنيش ميامي)", "شارع العيسوي", "شارع مصطفى كامل (ميامي)"],
    localNotes: ["أوناش مدمجة تتفادى الازدحام الصيفي والتجاري بشارع خالد بن الوليد وتصل للعميل بأمان.", "تغطية فورية للأعطال على الكورنيش ومحيط الأكاديمية البحرية."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ بشارع خالد بن الوليد أو جمال عبد الناصر بميامي؟",
            "a": "يصل الونش خلال 10 دقائق فقط لتواجد سياراتنا الدائم بقلب ميامي."
      }
,
      {
        "q": "هل تخدمون شاليهات وكمبوندات ميامي الشاطئية في الصيف؟",
        "a": "نعم، ميامي وإيدكو والطريق الساحلي الشرقي مغطاة 24 ساعة مع أولوية الاستجابة لحالات الشواطئ."
      }],
    nearby: ["المنتزه", "سيدي بشر", "العصافرة", "المندرة", "الإسكندرية"]
  },

  "محرم بك": {
    tier: 2,
    title: "ونش انقاذ محرم بك الإسكندرية",
    metaDescription: "ونش انقاذ محرم بك: كارفور سيتي سنتر، ميدان الرصافة، كوبري محرم بك، مطلع الطريق الصحراوي والزراعي. وصول 10 دقائق - 01044844492.",
    intro: "حي محرم بك البوابة الجنوبية الرئيسية للإسكندرية ومدخل الطريق الصحراوي والزراعي. أوناشنا متمركزة عند كوبري محرم بك ومجمع كارفور سيتي سنتر لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10 دقائق في محرم بك",
    landmarks: ["سيتي سنتر الإسكندرية (كارفور)", "كوبري محرم بك العلوي", "موقف محرم بك الإقليمي الجديد (الموقف الجديد)", "ميدان الرصافة", "مستشفى الجمهورية التعليمي"],
    streets: ["طريق الإسكندرية الصحراوي (مدخل محرم بك)", "طريق قنال السويس السكندري", "شارع الرصافة", "شارع محرم بك الرئيسي", "محور المحمودية"],
    localNotes: ["موقع استراتيجي يربط بين الموقف الجديد ومدخل الطريق الصحراوي والزراعي ومحور المحمودية.", "سحب آمن وسريع للمركبات ونقلها لورش محرم بك أو صيانة سموحة."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند كارفور سيتي سنتر وموقف محرم بك الجديد؟",
            "a": "نعم، أوناشنا متواجدة عند مدخل كارفور والموقف الجديد على مدار الساعة."
      }
,
      {
        "q": "ما الفرق في زمن الوصول بين محرم بك وسيدي جابر؟",
        "a": "محرم بك وسيدي جابر متقاربتان — وصولنا في 15-25 دقيقة لكليهما من نقطة تمركزنا في سموحة."
      }],
    nearby: ["سموحة", "كرموز", "الإسكندرية", "محور المحمودية", "طريق إسكندرية الصحراوي"]
  },

  "محطة الرمل": {
    tier: 1,
    title: "ونش انقاذ محطة الرمل وسط الإسكندرية",
    metaDescription: "ونش انقاذ محطة الرمل: ميدان سعد زغلول، شارع فؤاد، المنشية، المسلة، كورنيش الرمل. وصول 5-10 دقائق بخصم 50% - 01044844492.",
    intro: "محطة الرمل قلب الإسكندرية التجاري والتاريخي النابض. نوفر أوناش إنقاذ متمركزة في ميدان سعد زغلول وشارع فؤاد ومحيط سينما ريو ومحطة الترام لإنقاذ وسحب سيارات الملاكي في شوارع وسط الإسكندرية.",
    responseTime: "5–10 دقائق في محطة الرمل",
    landmarks: ["ميدان محطة الرمل ومحطة الترام التاريخية", "ميدان سعد زغلول والكورنيش", "شارع فؤاد التاريخي", "سينما مترو وسينما ريو", "فندق سيسيل التاريخي", "ميدان المنشية والمحاكم (بالقرب)"],
    streets: ["شارع سعد زغلول", "شارع فؤاد", "طريق الجيش (كورنيش الرمل)", "شارع السلطان حسين", "شارع النبي دانيال", "شارع صفية زغلول"],
    localNotes: ["أوناش مدمجة للمناورة في الشوارع التراثية والأزقة التجارية بمحطة الرمل والمنشية.", "تأمين فوري للسيارات في مواقف محطة الرمل وكورنيش النيل السكندري."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في ميدان محطة الرمل أو شارع فؤاد؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتمركزنا الدائم بميدان سعد زغلول."
      }
,
      {
        "q": "هل تخدمون منطقة محطة الرمل ووسط الإسكندرية؟",
        "a": "نعم، محطة الرمل وشارع النبي دانيال وميدان سعد زغلول وصولاً لقلعة قايتباي مغطاة كاملاً."
      }],
    nearby: ["الشاطبي", "المنشية", "الأزاريطة", "بحري", "الإسكندرية"]
  },

  "العجمي": {
    tier: 2,
    title: "ونش انقاذ العجمي والبيطاش والهانوفيل",
    metaDescription: "ونش انقاذ العجمي: البيطاش، الهانوفيل، الدخيلة، أكتوبر النخيل، طريق إسكندرية مطروح. وصول 15 دقيقة خدمة 24 ساعة - 01044844492.",
    intro: "منطقة العجمي (البيطاش، الهانوفيل، أبو تلات، 6 أكتوبر النخيل) غرب الإسكندرية. نوفر أوناش إنقاذ متمركزة على طريق إسكندرية - مطروح الساحلي لخدمة الأهالي والمصطافين طوال 24 ساعة.",
    responseTime: "15 دقيقة في العجمي",
    landmarks: ["ميدان البيطاش الرئيسي", "شارع الهانوفيل التجاري", "قرية 6 أكتوبر شاطئ النخيل", "ميناء الدخيلة (المدخل)", "مستشفى مبرة العجمي المركزية"],
    streets: ["طريق الإسكندرية - مطروح الساحلي", "شارع البيطاش الرئيسي", "شارع الهانوفيل", "شارع الدخيلة", "طريق أم زغيو"],
    localNotes: ["أوناش مجهزة للتحرك في الشوارع الساحلية والرمال وسحب السيارات العالقة على الشواطئ.", "تغطية كاملة للمحاور الرابطة بين العجمي وبرج العرب والطريق الساحلي الدولي."],
    faqs: [
      {
            "q": "هل تغطون شاطئ النخيل والبيطاش والهانوفيل بالعجمي؟",
            "a": "نعم، أوناشنا متواجدة على طريق مطروح الساحلي بالعجمي 24/7."
      }
,
      {
        "q": "هل تخدمون الطريق الساحلي الغربي من الإسكندرية حتى برج العرب؟",
        "a": "نعم، الطريق الدولي الساحلي من العجمي حتى برج العرب والعامرية ومطار برج العرب مغطى كاملاً."
      }],
    nearby: ["الإسكندرية", "برج العرب", "الدخيلة", "الساحل الشمالي", "طريق مطروح"]
  },

  "الساحل الشمالي": {
    tier: 1,
    title: "ونش انقاذ الساحل الشمالي والعلمين",
    metaDescription: "ونش انقاذ الساحل الشمالي: مارينا (1-7)، مراسي، هاسيندا، أمواج، بوابات الرسوم، سيدي عبد الرحمن. وصول 15-20 دقيقة - 01044844492.",
    intro: "الساحل الشمالي وجهة الاصطياف الأولى في مصر. ننشر أسطول أوناش سطحة هيدروليكية كاملة متمركزة على طريق الإسكندرية - مطروح الساحلي ومحور الضبعة من مارينا وحتى رأس الحكمة لخدمة كافة القرى السياحية والسيارات الفارهة.",
    responseTime: "15–20 دقيقة في الساحل الشمالي",
    landmarks: ["بوابات منتجع مارينا العلمين (1-7)", "منتجع مراسي Marassi", "هاسيندا باي وريد Hacienda", "قرية أمواج Amwaj", "منطقة سيدي عبد الرحمن", "منطقة خليج رأس الحكمة", "مطار العلمين الدولي"],
    streets: ["طريق الإسكندرية - مرسى مطروح الساحلي الدولي", "محور الضبعة الحر", "طريق وادي النطرون - العلمين", "طريق الفوكا الجديد"],
    localNotes: ["أوناش سطحة هيدروليكية متطورة مجهزة لنقل السيارات السوبر سبورت والفاخرة بأمان تام.", "إمكانية نقل وسحب السيارة من أي قرية بالساحل إلى القاهرة أو الإسكندرية مباشرة."],
    faqs: [
      {
            "q": "هل توفرون خدمة نقل السيارات من قرى الساحل الشمالي ومراسي إلى القاهرة؟",
            "a": "نعم، نوفر أوناش سطحة هيدروليكية لنقل سيارتك بأمان تام من باب الشاليه بالساحل إلى منزلك بالقاهرة."
      }
,
      {
        "q": "كيف يمكن الحجز المسبق لنقل سيارة في موسم الصيف للساحل؟",
        "a": "اتصل بنا على 01044844492 أو واتساب قبل 24-48 ساعة في الصيف لضمان توفر الأوناش."
      }],
    nearby: ["العلمين الجديدة", "مارينا", "مراسي", "سيدي عبد الرحمن", "الإسكندرية", "مرسى مطروح"]
  },

  "العلمين الجديدة": {
    tier: 1,
    title: "ونش انقاذ مدينة العلمين الجديدة",
    metaDescription: "ونش انقاذ العلمين الجديدة: أبراج العلمين، النورث سكوير، المنطقة التراثية، جامعة العلمين، طريق البترول. وصول 15 دقيقة بخصم 50% - 01044844492.",
    intro: "مدينة العلمين الجديدة درة البحر المتوسط وأحدث المدن الذكية الشاطئية في الشرق الأوسط. أوناش إنقاذ محمد بحر متمركزة عند أبراج العلمين الشاطئية ونورث سكوير مول لإنقاذ وسحب سيارات الملاكي والكهربائية (EVs) بأعلى معايير الدقة.",
    responseTime: "15 دقيقة في العلمين الجديدة",
    landmarks: ["أبراج العلمين الشاطئية Alamein Towers", "مول نورث سكوير North Square", "المدينة التراثية بالعلمين", "جامعة العلمين الدولية AIU", "الممشى السياحي واللاجون", "فندق ريجال هايتس العلمين"],
    streets: ["طريق العلمين الساحلي الدولي", "محور العلمين الجديد", "طريق البترول", "طريق وادي النطرون العلمين", "شارع الأبراج الشاطئية"],
    localNotes: ["تصاريح دخول رسمية للمشروعات الشاطئية والأبراج والأحياء السكنية اللاتينية.", "تجهيزات إنقاذ حديثة لسحب السيارات الكهربائية والسيارات الفاخرة بأمان تام."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام أبراج العلمين أو النورث سكوير؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجدنا الدائم على كورنيش ومحور العلمين الجديدة."
      }
,
      {
        "q": "هل يختلف السعر لنقل سيارة كلاسيكية أو فارهة إلى العلمين؟",
        "a": "نعم، السيارات الفارهة والكلاسيكية تستلزم أونش flatbed هيدروليك بتكلفة أعلى بـ 20-30%. اتصل للاستفسار."
      }],
    nearby: ["الساحل الشمالي", "مارينا", "سيدي عبد الرحمن", "طريق إسكندرية الصحراوي", "الإسكندرية"]
  },

  "مرسى مطروح": {
    tier: 2,
    title: "ونش انقاذ مرسى مطروح",
    metaDescription: "ونش انقاذ مرسى مطروح: شاطئ الغرام، كليوباترا، عجيبة، علم الروم، بوابات مطروح، طريق السلوم. وصول 15-20 دقيقة - 01044844492.",
    intro: "مدينة مرسى مطروح عاصمة السحر والجمال وواحة الشواطئ الفيروزية. نوفر أوناش إنقاذ متواجدة على مدار 24 ساعة لتغطية شواطئ مطروح وطريق الساحل الدولي حتى بوابات المدينة والسلوم.",
    responseTime: "15–20 دقيقة في مرسى مطروح",
    landmarks: ["هضبة وشاطئ عجيبة", "حمام وشاطئ كليوباترا", "شاطئ الغرام وليلى مراد", "شاطئ علم الروم والروميل", "بوابة رسوم مطروح (الكيلو 20)", "مطار مرسى مطروح الدولي"],
    streets: ["طريق الإسكندرية - مطروح الساحلي", "شارع الإسكندرية (وسط مطروح)", "شارع الجلاء مطروح", "طريق القصر - عجيبة", "طريق السلوم الدولي"],
    localNotes: ["أوناش مجهزة للتعامل مع المسافات الطويلة والطرق الساحلية والصحراوية بمطروح.", "توفير خدمات سحب السيارات ونقلها من مطروح إلى الإسكندرية أو القاهرة بأفضل الأسعار."],
    faqs: [
      {
            "q": "هل توفرون ونش سحب من مرسى مطروح إلى الإسكندرية والقاهرة؟",
            "a": "نعم، نوفر أوناش سطحة مجهزة لرحلات النقل الطويلة بين مطروح وباقي المحافظات."
      }
,
      {
        "q": "ما تكلفة نقل سيارة من القاهرة إلى مرسى مطروح؟",
        "a": "نقل من القاهرة إلى مرسى مطروح (470 كم): 2500-3500 ج.م حسب نوع السيارة. الحجز المسبق مطلوب."
      }],
    nearby: ["الساحل الشمالي", "العلمين الجديدة", "النجيلة", "السلوم", "سيوة"]
  },

  "المنصورة": {
    tier: 1,
    title: "ونش انقاذ المنصورة والدقهلية",
    metaDescription: "ونش انقاذ المنصورة: المشاية السفلية، جامعة المنصورة، حي الجامعة، توريل، كوبري طلخا، شارع الجيش. وصول 15 دقيقة بخصم 50% - 01044844492.",
    intro: "عروس النيل والدلتا، نوفر تغطية إنقاذ شاملة لكورنيش المشاية وحي الجامعة وطلخا وتوريل وسندوب لنجدة السيارات المعطلة وحالات الطوارئ طوال اليوم.",
    responseTime: "15 دقيقة في المنصورة",
    landmarks: ["جامعة المنصورة ومستشفى الكلى (غنيم)", "المشاية السفلية وكورنيش النيل بالمنصورة", "ميدان أم كلثوم والمحافظة", "حي توريل الراقي", "كوبري طلخا القديم والجديد", "استاد المنصورة الرياضي"],
    streets: ["شارع الجمهورية (المشاية السفلية)", "شارع الجيش المنصورة", "شارع جيهان (حي الجامعة)", "شارع قناة السويس المنصورة", "طريق المنصورة - دمياط الغربي", "طريق المنصورة - طنطا"],
    localNotes: ["أوناش مدمجة تناسب شوارع الدلتا الحيوية ومحيط مجمع المراكز الطبية العالمية بالمنصورة.", "خدمة تبديل إطارات وشحن بطاريات فورية أمام بوابات جامعة المنصورة وكوبري طلخا."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في حي الجامعة أو المشاية بالمنصورة؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجد سياراتنا الدائم بقلب المنصورة."
      }
,
      {
        "q": "هل تخدمون مدينة المنصورة وكورنيش النيل بها؟",
        "a": "نعم، المنصورة ومنطقة كورنيش النيل وجامعة المنصورة وطريق القاهرة الإسماعيلية من وإلى المنصورة مغطاة."
      }],
    nearby: ["الدقهلية", "طلخا", "طنطا", "الزقازيق", "دمياط", "المحلة الكبرى"]
  },

  "الدقهلية": {
    tier: 2,
    title: "ونش انقاذ محافظة الدقهلية",
    metaDescription: "ونش انقاذ محافظة الدقهلية: المنصورة، ميت غمر، السنبلاوين، دكرنس، بلقاس، جمصة. وصول 15-20 دقيقة - 01044844492.",
    intro: "تغطية شاملة لكافة مراكز ومدن محافظة الدقهلية، نخدم المنصورة، ميت غمر، السنبلاوين، شربين، ومدينة جمصة السياحية على الطريق الدولي الساحلي بأرخص الأسعار.",
    responseTime: "15–20 دقيقة في الدقهلية",
    landmarks: ["مدينة جمصة الساحلية", "مدينة ميت غمر", "مدينة السنبلاوين", "كوبري سندوب العلوي", "جامعة الدلتا بجمصة"],
    streets: ["طريق المنصورة - بنها الزراعي", "الطريق الدولي الساحلي (قطاع الدقهلية)", "طريق المنصورة - دمياط", "طريق السنبلاوين - الزقازيق"],
    localNotes: ["أوناش موزعة على مداخل المحافظة وطريق بنها والساحلي الدولي.", "توفير خدمات سحب ونقل لكافة أنواع المركبات الملاكي والنقل الخفيف."],
    faqs: [
      {
            "q": "هل تغطون مراكز ميت غمر وجمصة والسنبلاوين بالدقهلية؟",
            "a": "نعم، أوناشنا تغطي كافة مراكز وقرى محافظة الدقهلية 24/7."
      }
,
      {
        "q": "ما مدن الدقهلية التي تغطيها خدمتكم؟",
        "a": "نغطي المنصورة، ميت غمر، طلخا، طلبانة، شربين، والزقازيق (الشرقية) ضمن نطاق خدمتنا الممتدة."
      }],
    nearby: ["المنصورة", "الشرقية", "الغربية", "دمياط", "القليوبية"]
  },

  "طنطا": {
    tier: 1,
    title: "ونش انقاذ طنطا والغربية",
    metaDescription: "ونش انقاذ طنطا: ميدان السيد البدوي، شارع البحر، الاستاد، جامعة طنطا، كوبري المحطة، طريق إسكندرية الزراعي. وصول 15 دقيقة - 01044844492.",
    intro: "مدينة طنطا قلب الدلتا النابض وعاصمة محافظة الغربية. نوفر أوناش إنقاذ متمركزة عند شارع البحر وميدان المحطة ومحيط جامعة طنطا ومدخل الطريق الزراعي لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "15 دقيقة في طنطا",
    landmarks: ["مسجد السيد أحمد البدوي", "ميدان المحطة وساعة طنطا", "جامعة طنطا والمجمع الطبي", "استاد طنطا الرياضي", "كوبري المعرض العلوي", "مول طنطا Mall of Tanta"],
    streets: ["شارع الجيش (شارع البحر)", "شارع النحاس", "شارع سعيد", "شارع بطرس", "طريق مصر - إسكندرية الزراعي (قطاع طنطا)", "طريق طنطا - كفر الشيخ"],
    localNotes: ["أوناش متواجدة عند مدخل طنطا على الطريق الزراعي ومول طنطا لسرعة الاستجابة.", "تأمين سريع للسيارات المتعطلة ونقلها لأي مركز صيانة بطنطا أو القاهرة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في شارع البحر أو أمام جامعة طنطا؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجدنا المستمر بشوارع طنطا الرئيسية."
      }
,
      {
        "q": "ما زمن الوصول من القاهرة إلى طنطا؟",
        "a": "من القاهرة إلى طنطا (94 كم) عبر طريق القاهرة الإسكندرية الصحراوي: 60-80 دقيقة. خدمة نقل ثابتة وموثوقة."
      }],
    nearby: ["الغربية", "المحلة الكبرى", "المنصورة", "بنها", "كفر الشيخ", "الزقازيق"]
  },

  "الغربية": {
    tier: 2,
    title: "ونش انقاذ محافظة الغربية",
    metaDescription: "ونش انقاذ محافظة الغربية: طنطا، المحلة الكبرى، زفتى، كفر الزيات، سمنود، بسيون. وصول 15-20 دقيقة - 01044844492.",
    intro: "خدمة ونش إنقاذ وسحب سيارات متكاملة تغطي محافظة الغربية بالكامل: طنطا، المحلة الكبرى قلعة الغزل والنسيج، زفتى، كفر الزيات، ومسارات الطريق الزراعي السريع.",
    responseTime: "15–20 دقيقة في الغربية",
    landmarks: ["مدينة المحلة الكبرى ومصانع غزل المحلة", "مدينة كفر الزيات على النيل", "مدينة زفتى", "كوبري كفر الزيات العلوي", "مستشفى الأورام بطنطا"],
    streets: ["طريق القاهرة - الإسكندرية الزراعي", "طريق طنطا - المحلة الكبرى السريع", "طريق المحلة - المنصورة", "طريق زفتى - طنطا"],
    localNotes: ["أوناش مجهزة لنقل الشاحنات وسيارات النقل وسيارات الموظفين بالمحلة وطنطا.", "تغطية فورية لأعطال وحوادث الطريق الزراعي المزدحم في نطاق المحافظة."],
    faqs: [
      {
            "q": "هل تغطون مدينة المحلة الكبرى وكفر الزيات بالغربية؟",
            "a": "نعم، أوناشنا متواجدة بالمحلة وكفر الزيات وطنطا على مدار 24 ساعة."
      }
,
      {
        "q": "ما المدن التي تغطيها خدمتكم في محافظة الغربية؟",
        "a": "نغطي طنطا والمحلة الكبرى وكفر الزيات وزفتى وسمسطا في الغربية ضمن نطاق النقل والإنقاذ."
      }],
    nearby: ["طنطا", "الدقهلية", "المنوفية", "كفر الشيخ", "البحيرة"]
  },

  "الزقازيق": {
    tier: 1,
    title: "ونش انقاذ الزقازيق والشرقية",
    metaDescription: "ونش انقاذ الزقازيق: جامعة الزقازيق، شارع القومية، ميدان الصاغة، موقف المنصورة، كوبري الصاغة. وصول 15 دقيقة بخصم 50% - 01044844492.",
    intro: "مدينة الزقازيق عاصمة محافظة الشرقية وكبرى مدن شرق الدلتا. أوناش إنقاذ محمد بحر متمركزة في حي القومية ومحيط جامعة الزقازيق وميدان المحطة لتقديم خدمة سحب ورفع سيارات سريعة وموثوقة 24/7.",
    responseTime: "15 دقيقة في الزقازيق",
    landmarks: ["جامعة الزقازيق ومستشفى جامعة الزقازيق", "حي القومية الراقي", "ميدان طلعت حرب والصاغة", "ميدان المحطة بالزقازيق", "استاد الزقازيق الرياضي", "كوبري الممر العلوي"],
    streets: ["شارع القومية التجاري", "شارع طلبة عويضة", "شارع فاروق", "شارع سعد زغلول الزقازيق", "طريق الزقازيق - بلبيس", "طريق الزقازيق - ميت غمر"],
    localNotes: ["أوناش متواجدة بحي القومية والجامعة لخدمة الحالات الطارئة وأعطال الطلاب والمواطنين.", "سحب آمن للمركبات ونقلها لمراكز صيانة الزقازيق أو العاشر من رمضان أو القاهرة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في حي القومية أو أمام جامعة الزقازيق؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجد سياراتنا الدائم بقلب الزقازيق."
      }
,
      {
        "q": "هل تخدمون منطقة صناعية الزقازيق والعاشر من رمضان القريبة؟",
        "a": "نعم، الزقازيق والعاشر من رمضان على طريق الإسماعيلية مغطاة كاملاً بخدمة النقل والإنقاذ الفوري."
      }],
    nearby: ["الشرقية", "بلبيس", "العاشر من رمضان", "ميت غمر", "المنصورة", "الإسماعيلية"]
  },

  "الشرقية": {
    tier: 2,
    title: "ونش انقاذ محافظة الشرقية",
    metaDescription: "ونش انقاذ محافظة الشرقية: الزقازيق، العاشر من رمضان، بلبيس، فاقوس، منيا القمح، الحسينية. وصول 15-20 دقيقة - 01044844492.",
    intro: "نغطي كافة مراكز ومدن محافظة الشرقية، نخدم الزقازيق، مدينة العاشر من رمضان الصناعية، بلبيس، فاقوس، ومنيا القمح وطريق بلبيس الصحراوي بأحدث أوناش السحب الثقيلة والخفيفة.",
    responseTime: "15–20 دقيقة في الشرقية",
    landmarks: ["مدينة العاشر من رمضان", "مدينة بلبيس وبوابة الشرقية", "مدينة فاقوس", "ميدان الطيارة ببلبيس", "منطقة تل بسطة الأثرية"],
    streets: ["طريق القاهرة - بلبيس الصحراوي", "طريق الإسماعيلية الصحراوي (نطاق الشرقية)", "طريق الزقازيق - فاقوس", "طريق أبو حماد - الإسماعيلية"],
    localNotes: ["أوناش متمركزة عند بوابات العاشر من رمضان وبلبيس لتأمين الشاحنات وسيارات الملاكي.", "خدمات طوارئ فورية لشحن البطاريات وتغيير الإطارات على الطرق الزراعية والصحراوية."],
    faqs: [
      {
            "q": "هل تغطون مراكز فاقوس ومنيا القمح وبلبيس بالشرقية؟",
            "a": "نعم، أوناشنا تغطي كافة مراكز وطرق محافظة الشرقية على مدار 24 ساعة."
      }
,
      {
        "q": "ما زمن الوصول من القاهرة إلى الزقازيق؟",
        "a": "من القاهرة إلى الزقازيق: 60-80 دقيقة عبر طريق الإسماعيلية. للعاشر من رمضان: 40-50 دقيقة."
      }],
    nearby: ["الزقازيق", "العاشر من رمضان", "القليوبية", "الإسماعيلية", "الدقهلية"]
  },

  "العاشر من رمضان": {
    tier: 1,
    title: "ونش انقاذ العاشر من رمضان",
    metaDescription: "ونش انقاذ العاشر من رمضان: المناطق الصناعية (A1-C6)، الأردنية، كفراوي، طريق الإسماعيلية، صيدناوي. وصول 10-15 دقيقة - 01044844492.",
    intro: "مدينة العاشر من رمضان أكبر قلعة صناعية في مصر. نوفر أسطول أوناش إنقاذ ثقيلة وسطحات متمركزة في منطقة الأردنية والمناطق الصناعية (B1 إلى B4) وطريق الإسماعيلية لخدمة المصانع والشاحنات وسيارات الموظفين طوال 24 ساعة.",
    responseTime: "10–15 دقيقة في العاشر من رمضان",
    landmarks: ["منطقة الأردنية والموقف الرئيسي", "ميدان الرواد ونادي الرواد", "ميدان صيدناوي", "المنطقة الصناعية الثالثة والرابعة", "هايبر وان العاشر من رمضان", "جامعة الزقازيق الأهلية بالعاشر"],
    streets: ["طريق القاهرة - الإسماعيلية الصحراوي (مدخل العاشر)", "شارع صيدناوي", "محور الكفراوي", "طريق بلبيس - العاشر", "شارع حسن الألفي الصناعي"],
    localNotes: ["أوناش ثقيلة متخصصة لسحب سيارات النقل والتريلات والمعدات بالمناطق الصناعية.", "تغطية فورية لأعطال سيارات الملاكي والركاب على طريق الإسماعيلية ومحور الكفراوي."],
    faqs: [
      {
            "q": "هل توفرون ونش سحب للشاحنات والمعدات الثقيلة في العاشر من رمضان؟",
            "a": "نعم، لدينا أوناش مخصصة للملاكي وأوناش ثقيلة لكافة معدات وشاحنات المصانع."
      }
,
      {
        "q": "هل تخدمون المناطق الصناعية والمجمعات في العاشر من رمضان؟",
        "a": "نعم، المنطقة الصناعية الأولى والثانية والثالثة في العاشر من رمضان مغطاة بأوناشنا الصناعية."
      }],
    nearby: ["الشرقية", "العبور", "الشروق", "بدر", "طريق الإسماعيلية", "بلبيس"]
  },

  "العبور": {
    tier: 1,
    title: "ونش انقاذ مدينة العبور",
    metaDescription: "ونش انقاذ العبور: سوق العبور، الحي الأول إلى التاسع، جولف سيتي، خط 10، طريق الإسماعيلية، جامعة بنها. وصول 10-15 دقيقة - 01044844492.",
    intro: "مدينة العبور حلقة الوصل الصناعية والسكنية الراقية بين القاهرة والقليوبية والشرقية. أوناشنا متمركزة عند سوق العبور ومول جولف سيتي ومحور العبور لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة في العبور",
    landmarks: ["سوق العبور للجملة", "جولف سيتي مول وملاعب الجولف", "جامعة بنها الأهلية بالعبور", "نادي العبور الرياضي", "كارفور العبور", "مستشفى العبور التخصصي"],
    streets: ["طريق القاهرة - الإسماعيلية الصحراوي (مدخل العبور)", "محور العبور الرئيسي", "طريق خط 10", "طريق خط 12", "محور بلبيس - العبور"],
    localNotes: ["تمركز بالقرب من سوق العبور وجولف سيتي لتغطية كافة الأحياء السكنية والصناعية.", "أوناش سطحة مجهزة لنقل السيارات الفاخرة وسيارات النقل الخفيف بدون أي احتكاك."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام سوق العبور أو جولف سيتي؟",
            "a": "أقل من 10 دقائق لتواجد سياراتنا المستمر عند مدخل العبور على طريق الإسماعيلية."
      }
,
      {
        "q": "هل تخدمون مدينة العبور والكمبوندات الجديدة بها؟",
        "a": "نعم، نغطي مدينة العبور بالكامل من مدخل الدائري إلى الحي السابع والثامن والكمبوندات الجديدة."
      }],
    nearby: ["العاشر من رمضان", "الهايكستب", "الشروق", "مدينة السلام", "طريق الإسماعيلية", "قليوب"]
  },

  "بنها": {
    tier: 1,
    title: "ونش انقاذ بنها والقليوبية",
    metaDescription: "ونش انقاذ بنها: كورنيش النيل، جامعة بنها، الفلل، كوبري الفحص، مطلع طريق شبرا بنها الحر والطريق الزراعي. وصول 15 دقيقة - 01044844492.",
    intro: "مدينة بنها عاصمة محافظة القليوبية وملتقى شبكة الطرق السريعة (شبرا بنها الحر، الزراعي، الإقليمي). أوناش إنقاذ محمد بحر متمركزة في الفلل والكوبري الجديد ومحيط جامعة بنها لإنقاذ فوري 24 ساعة.",
    responseTime: "15 دقيقة في بنها",
    landmarks: ["جامعة بنها والمستشفى الجامعي", "منطقة الفلل الراقية وكورنيش النيل ببنها", "كوبري الفحص وكوبري كفر الجزار", "ميدان المحطة ببنها", "مطلع طريق شبرا بنها الحر", "استاد بنها الرياضي"],
    streets: ["شارع كورنيش النيل بنها", "شارع فريد ندا", "طريق شبرا - بنها الحر", "طريق القاهرة - الإسكندرية الزراعي", "طريق بنها - المنصورة السريع", "طريق بنها - الزقازيق"],
    localNotes: ["تمركز استراتيجي عند مخرج طريق شبرا بنها الحر وميدان الإشارة ببنها.", "سحب آمن وسريع للمركبات المتعطلة على الطرق الحرة والزراعية المحيطة ببنها."],
    faqs: [
      {
            "q": "هل تغطون طريق شبرا بنها الحر وكورنيش بنها؟",
            "a": "نعم، أوناشنا متواجدة على طريق شبرا بنها الحر ومداخل بنها على مدار 24 ساعة."
      }
,
      {
        "q": "ما زمن الوصول من القاهرة إلى بنها؟",
        "a": "من القاهرة إلى بنها (40 كم) عبر طريق القليوبية: 40-50 دقيقة. من أقرب مناطق الدلتا للقاهرة."
      }],
    nearby: ["قليوب", "القليوبية", "طريق شبرا بنها الحر", "طنطا", "المنصورة", "الزقازيق"]
  },

  "قليوب": {
    tier: 2,
    title: "ونش انقاذ قليوب والمؤسسة",
    metaDescription: "ونش انقاذ قليوب: مزلقان قليوب، محطة قطار قليوب، مطلع الطريق الدائري، طريق إسكندرية الزراعي، ميت حلفا. وصول 10-15 دقيقة - 01044844492.",
    intro: "مدينة قليوب البوابة الشمالية الأولى للقاهرة الكبرى على الطريق الزراعي. نوفر أوناش إنقاذ متمركزة عند مزلقان قليوب ونزلة الدائري وميت حلفا لإنقاذ سريع للمركبات طوال 24 ساعة.",
    responseTime: "10–15 دقيقة في قليوب",
    landmarks: ["محطة قطار قليوب والمزلقان", "تقاطع الطريق الدائري مع الزراعي (المؤسسة/قليوب)", "مستشفى قليوب التخصصي", "سوق قليوب التجاري", "كوبري قلما العلوي"],
    streets: ["طريق القاهرة - الإسكندرية الزراعي (قطاع قليوب)", "الطريق الدائري", "طريق سنديون", "طريق ميت حلفا", "شارع العاشر من رمضان قليوب"],
    localNotes: ["أوناش متواجدة عند مدخل الزراعي والدائري لتأمين الحوادث والأعطال السريعة.", "توفير خدمات وصلة البطارية وتغيير الإطارات وسحب آمن للمركبات."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ عند مزلقان قليوب أو مدخل الدائري؟",
            "a": "يصل الونش خلال 10 إلى 15 دقيقة من أقرب نقطة تمركز بالمؤسسة وقليوب."
      }
,
      {
        "q": "ما زمن الوصول من القاهرة إلى قليوب؟",
        "a": "من القاهرة المركزية نصل لقليوب في 20-30 دقيقة عبر طريق إسكندرية الصحراوي أو طريق القليوبية."
      }],
    nearby: ["بنها", "القليوبية", "شبرا الخيمة", "الطريق الدائري", "طريق شبرا بنها الحر"]
  },

  "القليوبية": {
    tier: 2,
    title: "ونش انقاذ محافظة القليوبية",
    metaDescription: "ونش انقاذ محافظة القليوبية: بنها، قليوب، شبرا الخيمة، العبور، الخانكة، القناطر الخيرية، طوخ. وصول 15-20 دقيقة - 01044844492.",
    intro: "تغطية شاملة لكافة مراكز ومدن محافظة القليوبية، نخدم بنها، قليوب، شبرا الخيمة، مدينة العبور، القناطر الخيرية، وطوخ على طريقي الزراعي وشبرا بنها الحر بأفضل الأسعار.",
    responseTime: "15–20 دقيقة في القليوبية",
    landmarks: ["حدائق وقناطر القناطر الخيرية", "مدينة طوخ وقها", "مدينة الخانكة وأبو زعبل", "كوبري شبرا الخيمة العلوي", "جامعة بنها"],
    streets: ["طريق شبرا - بنها الحر", "طريق القاهرة - الإسكندرية الزراعي", "طريق الإسماعيلية الصحراوي (نطاق القليوبية)", "طريق خط 12 القناطر"],
    localNotes: ["أوناش موزعة على المحاور الزراعية والحرة والصحراوية بالقليوبية.", "جاهزية كاملة لإنقاذ كافة أنواع السيارات الملاكي والنقل والميكروباص."],
    faqs: [
      {
            "q": "هل تغطون القناطر الخيرية وطوخ وقها بمحافظة القليوبية؟",
            "a": "نعم، أوناشنا تغطي كافة مراكز وطرق القليوبية 24/7 دون انقطاع."
      }
,
      {
        "q": "هل تغطون مدن القليوبية الصناعية؟",
        "a": "نعم، شبرا الخيمة وقليوب وخصوص والقناطر الخيرية في القليوبية مغطاة بأسطولنا."
      }],
    nearby: ["بنها", "قليوب", "العبور", "شبرا الخيمة", "المنوفية", "الشرقية"]
  },

  "شبين الكوم": {
    tier: 1,
    title: "ونش انقاذ شبين الكوم والمنوفية",
    metaDescription: "ونش انقاذ شبين الكوم: جامعة المنوفية، شارع باريس، شارع الجلاء، مجمع الكليات، كوبري مبارك، الاستاد. وصول 15 دقيقة بخصم 50% - 01044844492.",
    intro: "مدينة شبين الكوم عاصمة محافظة المنوفية والمركز الجامعي الأكبر بالمحافظة. أوناش إنقاذ محمد بحر متمركزة في شارع باريس ومحيط جامعة المنوفية واستاد شبين الكوم لخدمة سريعة للمركبات على مدار 24 ساعة.",
    responseTime: "15 دقيقة في شبين الكوم",
    landmarks: ["جامعة المنوفية والمجمع الطبي الجامعي", "شارع باريس الراقي", "ميدان شرف وميدان المحطة", "استاد شبين الكوم الرياضي", "كوبري مبارك العلوي وكورنيش شبين الكوم"],
    streets: ["شارع جمال عبد الناصر (البحر)", "شارع باريس", "شارع الجلاء شبين الكوم", "شارع صبري أبو علم", "طريق شبين الكوم - قويسنا", "طريق شبين الكوم - طنطا"],
    localNotes: ["تمركز عند مدخل شبين الكوم من طريق قويسنا والزراعي لسرعة الاستجابة.", "أوناش سطحة مجهزة لنقل السيارات داخل المنوفية أو السفر بها للقاهرة والإسكندرية."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في شارع باريس أو أمام جامعة المنوفية بشبين الكوم؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجد سياراتنا الدائم بقلب شبين الكوم."
      }
,
      {
        "q": "هل تخدمون شبين الكوم ومدن المنوفية؟",
        "a": "نعم، شبين الكوم وطنطا وأسبط ومنوف مغطاة بخدمة النقل والإنقاذ ضمن منطقة الدلتا."
      }],
    nearby: ["المنوفية", "قويسنا", "بركة السبع", "منوف", "طنطا", "بنها"]
  },

  "المنوفية": {
    tier: 2,
    title: "ونش انقاذ محافظة المنوفية",
    metaDescription: "ونش انقاذ محافظة المنوفية: شبين الكوم، قويسنا، مدينة السادات، منوف، أشمون، بركة السبع، الباجور. وصول 15-20 دقيقة - 01044844492.",
    intro: "خدمة ونش إنقاذ متكاملة تغطي محافظة المنوفية بالكامل: شبين الكوم، قويسنا والمنطقة الصناعية، مدينة السادات على الصحراوي، منوف، أشمون، والباجور بأحدث أوناش السحب.",
    responseTime: "15–20 دقيقة في المنوفية",
    landmarks: ["المنطقة الصناعية بقويسنا", "مدينة السادات الصناعية والجامعية", "مدينة منوف التاريخية", "مدينة أشمون", "كوبري بركة السبع على الزراعي"],
    streets: ["طريق القاهرة - الإسكندرية الزراعي (قطاع قويسنا وبركة السبع)", "طريق القاهرة - الإسكندرية الصحراوي (مدخل السادات)", "طريق شبين الكوم - الباجور", "طريق شبين الكوم - السادات"],
    localNotes: ["أوناش متمركزة عند المنطقة الصناعية بقويسنا ومدينة السادات لخدمة سيارات المصانع والملاكي.", "تغطية شاملة للطرق الزراعية والإقليمية داخل محافظة المنوفية."],
    faqs: [
      {
            "q": "هل تغطون المنطقة الصناعية بقويسنا ومدينة السادات بالمنوفية؟",
            "a": "نعم، أوناشنا متواجدة بقويسنا والسادات وشبين الكوم على مدار 24 ساعة."
      }
,
      {
        "q": "هل تخدمون شبين الكوم وسرس الليان والمنوفية؟",
        "a": "نعم، شبين الكوم وسرس الليان وطنطا (الغربية) والمنوفية كاملة في نطاق خدمة النقل والإنقاذ."
      }],
    nearby: ["شبين الكوم", "الغربية", "القليوبية", "البحيرة", "الجيزة"]
  },

  "دمنهور": {
    tier: 1,
    title: "ونش انقاذ دمنهور والبحيرة",
    metaDescription: "ونش انقاذ دمنهور: جامعة دمنهور، ميدان المحطة، شارع عبد السلام الشاذلي، مجمع المحاكم، كوبري دمنهور الزراعي. وصول 15 دقيقة - 01044844492.",
    intro: "مدينة دمنهور عاصمة محافظة البحيرة وملتقى مسارات الدلتا المؤدية للإسكندرية. نوفر أوناش إنقاذ متمركزة عند مدخل دمنهور على الطريق الزراعي ومحيط جامعة دمنهور وشارع عبد السلام الشاذلي لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "15 دقيقة في دمنهور",
    landmarks: ["جامعة دمنهور والمجمع النظري بالأبعادية", "دار أوبرا دمنهور التاريخية", "ميدان المحطة والساعة بدمنهور", "شارع عبد السلام الشاذلي", "مستشفى دمنهور التعليمي العام", "كوبري دمنهور العلوي على الزراعي"],
    streets: ["طريق القاهرة - الإسكندرية الزراعي (قطاع دمنهور)", "شارع عبد السلام الشاذلي", "شارع الجمهورية دمنهور", "طريق دمنهور - حوش عيسى", "طريق دمنهور - دسوق"],
    localNotes: ["أوناش متواجدة عند مطلع ومنزل كوبري دمنهور العلوي على الطريق الزراعي السريع.", "سحب آمن وسريع للمركبات ونقلها لمراكز صيانة دمنهور أو الإسكندرية أو طنطا."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ بشارع عبد السلام الشاذلي أو الطريق الزراعي بدمنهور؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجد سياراتنا الدائم بقلب دمنهور."
      }
,
      {
        "q": "ما زمن الوصول من القاهرة إلى دمنهور؟",
        "a": "من القاهرة إلى دمنهور (180 كم) عبر الإسكندرية الصحراوي: 90-120 دقيقة. خدمة نقل متاحة على مدار اليوم."
      }],
    nearby: ["البحيرة", "كفر الدوار", "الإسكندرية", "إيتاي البارود", "طنطا", "دسوق"]
  },

  "البحيرة": {
    tier: 2,
    title: "ونش انقاذ محافظة البحيرة",
    metaDescription: "ونش انقاذ محافظة البحيرة: دمنهور، كفر الدوار، وادي النطرون، إدكو، رشيد، أبو المطامير، بدر. وصول 15-20 دقيقة - 01044844492.",
    intro: "نغطي كافة مراكز ومدن محافظة البحيرة الواسعة: دمنهور، كفر الدوار، وادي النطرون على الطريق الصحراوي، مدينة رشيد الساحلية، وإدكو بأحدث أوناش الإنقاذ والسحب المجهزة.",
    responseTime: "15–20 دقيقة في البحيرة",
    landmarks: ["مدينة وادي النطرون وأديرتها التاريخية", "مدينة كفر الدوار الصناعية", "مدينة رشيد ومصب النيل", "مدينة النوبارية الجديدة", "الطريق الدولي الساحلي بالبحيرة"],
    streets: ["طريق القاهرة - الإسكندرية الزراعي", "طريق القاهرة - الإسكندرية الصحراوي (نطاق البحيرة)", "طريق وادي النطرون - العلمين", "الطريق الدولي الساحلي (إدكو ورشيد)"],
    localNotes: ["أوناش متمركزة عند رست وادي النطرون والصحراوي لخدمة سيارات السفر السريعة.", "تغطية كاملة للمدن الساحلية والصناعية والزراعية بمحافظة البحيرة."],
    faqs: [
      {
            "q": "هل تغطون طريق وادي النطرون وكفر الدوار بالبحيرة؟",
            "a": "نعم، أوناشنا متواجدة على طريقي الزراعي والصحراوي بالبحيرة 24/7."
      }
,
      {
        "q": "هل لديكم خدمة إنقاذ في مدينة دمنهور وكفر الدوار؟",
        "a": "نعم، دمنهور وكفر الدوار والمحلة الكبرى وكل مدن البحيرة مغطاة بخدمة الإنقاذ والنقل."
      }],
    nearby: ["دمنهور", "الإسكندرية", "الغربية", "المنوفية", "مطروح"]
  },

  "دمياط": {
    tier: 1,
    title: "ونش انقاذ دمياط ورأس البر",
    metaDescription: "ونش انقاذ دمياط: رأس البر، اللسان، ميناء دمياط، دمياط الجديدة، كوبري دمياط المعدني، شارع الجلاء. وصول 15 دقيقة بخصم 50% - 01044844492.",
    intro: "محافظة دمياط عاصمة صناعة الأثاث والملاحة البحرية ومصيف رأس البر الساحر. أوناش إنقاذ محمد بحر متمركزة في دمياط الجديدة ورأس البر وميناء دمياط لتقديم خدمة سحب سيارات فورية وآمنة 24/7.",
    responseTime: "15 دقيقة في دمياط",
    landmarks: ["شاطئ ومنطقة اللسان برأس البر", "ميناء دمياط ومحطة الحاويات", "جامعة دمياط بدمياط الجديدة", "مدينة دمياط للأثاث بالشنباص", "كوبري دمياط المعدني التاريخي", "فندق شتيجنبرجر اللسان"],
    streets: ["طريق دمياط - رأس البر السريع", "الطريق الدولي الساحلي (قطاع دمياط)", "طريق دمياط - المنصورة", "شارع الجلاء دمياط", "طريق ميناء دمياط"],
    localNotes: ["أوناش سطحة مجهزة لخدمة المصطافين برأس البر والشركات والشاحنات بميناء دمياط.", "تأمين سريع للسيارات المتعطلة على الطريق الدولي الساحلي وطريق المنصورة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في رأس البر أو دمياط الجديدة؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجد سياراتنا الدائم برأس البر ودمياط الجديدة."
      }
,
      {
        "q": "هل تخدمون ميناء دمياط والمنطقة الصناعية؟",
        "a": "نعم، مدينة دمياط والمنطقة الصناعية والميناء ورأس البر والعاصمة الصناعية مغطاة بخدمة النقل."
      }],
    nearby: ["رأس البر", "دمياط الجديدة", "المنصورة", "بورسعيد", "الدقهلية", "كفر الشيخ"]
  },

  "كفر الشيخ": {
    tier: 1,
    title: "ونش انقاذ كفر الشيخ وبلطيم",
    metaDescription: "ونش انقاذ كفر الشيخ: جامعة كفر الشيخ، مصيف بلطيم، دسوق، كوبري سخا، الطريق الدولي الساحلي. وصول 15-20 دقيقة - 01044844492.",
    intro: "محافظة كفر الشيخ قلعة الاستزراع السمكي والشواطئ الهادئة في شمال الدلتا. نوفر أوناش إنقاذ متمركزة في مدينة كفر الشيخ ودسوق ومصيف بلطيم لإنقاذ وسحب السيارات على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة في كفر الشيخ",
    landmarks: ["جامعة كفر الشيخ ومستشفاها الجامعي", "مسجد العارف بالله إبراهيم الدسوقي بدسوق", "مصيف بلطيم وشواطئه الفيروزية", "ميدان النصر بكفر الشيخ", "متحف كفر الشيخ الإقليمي", "محطة بحوث سخا"],
    streets: ["طريق كفر الشيخ - طنطا السريع", "الطريق الدولي الساحلي (قطاع كفر الشيخ وبلطيم)", "طريق كفر الشيخ - دسوق", "شارع الجيش كفر الشيخ", "شارع الخليفة المأمون كفر الشيخ"],
    localNotes: ["أوناش متواجدة عند مدخل كفر الشيخ ومصيف بلطيم على الطريق الدولي الساحلي.", "سحب آمن وسريع للسيارات ونقلها لمراكز صيانة كفر الشيخ أو طنطا أو الإسكندرية."],
    faqs: [
      {
            "q": "هل تغطون مصيف بلطيم ومدينة دسوق بمحافظة كفر الشيخ؟",
            "a": "نعم، أوناشنا متواجدة ببلطيم ودسوق وكفر الشيخ على مدار 24 ساعة."
      }
,
      {
        "q": "ما المدن الرئيسية في كفر الشيخ التي تشملها خدمتكم؟",
        "a": "نغطي كفر الشيخ ودسوق وفوه وبلطيم وسيدي سالم والبرلس في نطاق خدمة النقل والإنقاذ."
      }],
    nearby: ["طنطا", "دسوق", "بلطيم", "البحيرة", "الغربية", "دمياط"]
  },

  "بورسعيد": {
    tier: 1,
    title: "ونش انقاذ بورسعيد وبورفؤاد",
    metaDescription: "ونش انقاذ بورسعيد: منفذ الجميل، جمرك بورسعيد، بورفؤاد، المعديات، كوبري النصر العائم، شارع محمد علي. وصول 10-15 دقيقة - 01044844492.",
    intro: "المدينة الباسلة بورسعيد والمنطقة الحرة على المدخل الشمالي لقناة السويس. أوناش إنقاذ محمد بحر متمركزة في بورسعيد وبورفؤاد ومنافذ الجمرك ومحور 30 يونيو لإنقاذ وسحب سيارات الملاكي والمنطقة الحرة طوال 24 ساعة.",
    responseTime: "10–15 دقيقة في بورسعيد",
    landmarks: ["مبنى هيئة قناة السويس التاريخي", "المعديات الرابطة بين بورسعيد وبورفؤاد", "كوبري النصر العائم ببورفؤاد", "جبال الملاحات ببورفؤاد", "منفذ الجميل ومنفذ النصر الجمركي", "استاد النادي المصري البورسعيدي"],
    streets: ["شارع محمد علي (بورسعيد)", "طريق الكورنيش (طريق فلسطين)", "شارع 23 يوليو بورسعيد", "محور 30 يونيو (بداية بورسعيد)", "طريق بورسعيد - الإسماعيلية", "طريق دمياط - بورسعيد الساحلي"],
    localNotes: ["أوناش هيدروليكية مجهزة لنقل سيارات المنطقة الحرة والسيارات المستوردة عبر الجمارك بأمان تام.", "تغطية فورية لحالات الطوارئ بمحيط منفذ الجميل ومعديات بورسعيد وبورفؤاد."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في بورسعيد أو بورفؤاد؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتواجد سياراتنا الدائم بقلب بورسعيد ومنافذ الجمارك."
      }
,
      {
        "q": "ما تكلفة نقل سيارة من القاهرة إلى بورسعيد؟",
        "a": "النقل من القاهرة إلى بورسعيد: 800-1500 ج.م حسب نوع السيارة. مسافة 220 كم تستغرق 2.5-3 ساعات."
      }],
    nearby: ["جمرك بورسعيد", "بورفؤاد", "محور 30 يونيو", "الإسماعيلية", "دمياط", "طريق الإسماعيلية"]
  },

  "جمرك بورسعيد": {
    tier: 2,
    title: "ونش انقاذ جمرك بورسعيد والمنافذ الجمركية",
    metaDescription: "ونش انقاذ جمرك بورسعيد: منفذ الجميل، منفذ النصر، منفذ الرسوة، ساحات الإفراج الجمركي. وصول 10 دقائق - 01044844492.",
    intro: "نوفر خدمة ونش إنقاذ وسحب سيارات متخصصة بساحات ومنافذ جمرك بورسعيد (منفذ الجميل، النصر، والرسوة)، لنقل سيارات الإفراج الجمركي والسيارات المعطلة بأعلى درجات الأمان والالتزام باللوائح.",
    responseTime: "10 دقائق عند جمرك بورسعيد",
    landmarks: ["منفذ الجميل الجمركي (طريق دمياط)", "منفذ الرسوة الجمركي (طريق الإسماعيلية)", "منفذ النصر الجمركي (محور 30 يونيو)", "ساحة الإفراج الجمركي للسيارات", "ميناء غرب وشرق بورسعيد"],
    streets: ["طريق المنفذ الجمركي", "محور 30 يونيو الجمركي", "طريق الشاحنات بورسعيد", "طريق بورسعيد - الإسماعيلية السريع"],
    localNotes: ["أوناش سطحة مجهزة بأوراق وتراخيص رسمية للدخول والنقل من ساحات الإفراج الجمركي.", "إمكانية شحن وسحب السيارة من جمرك بورسعيد إلى أي محافظة في مصر مباشرة."],
    faqs: [
      {
            "q": "هل يمكن للونش نقل سيارة إفراج جمركي من بورسعيد إلى القاهرة؟",
            "a": "نعم، نوفر أوناش سطحة لنقل السيارات الجمركية فور إنهاء إجراءات الإفراج إلى أي عنوان يحدده العميل."
      }
,
      {
        "q": "هل تساعدون في استلام السيارات القادمة عبر ميناء بورسعيد؟",
        "a": "نعم، نقدم خدمة استلام السيارات من ميناء بورسعيد وجمارك الميناء وتوصيلها إلى القاهرة بأمان."
      }],
    nearby: ["بورسعيد", "محور 30 يونيو", "الإسماعيلية", "دمياط"]
  },

  "السويس": {
    tier: 1,
    title: "ونش انقاذ السويس",
    metaDescription: "ونش انقاذ السويس: بورتوفيق، الأربعين، فيصل السويس، طريق السويس القاهرة، نفق أحمد حمدي، العين السخنة. وصول 10-15 دقيقة - 01044844492.",
    intro: "مدينة السويس الباسلة المدخل الجنوبي لقناة السويس وبوابة البحر الأحمر. أوناش إنقاذ محمد بحر متمركزة في بورتوفيق وحي الأربعين وفيصل السويس ومداخل نفق الشهيد أحمد حمدي لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة في السويس",
    landmarks: ["كورنيش بورتوفيق والمدخل الجنوبي للقناة", "ميدان الأربعين الشهير", "ميدان الشهداء ومبنى المحافظة", "بوابة نفق الشهيد أحمد حمدي", "ميناء السويس وميناء الأدبية", "جامعة السويس"],
    streets: ["شارع الجيش بالسويس", "طريق القاهرة - السويس الصحراوي", "طريق السويس - العين السخنة", "طريق السويس - الإسماعيلية", "شارع كورنيش السويس الجديد", "شارع بورسعيد السويس"],
    localNotes: ["أوناش متواجدة عند مداخل السويس ونفق أحمد حمدي لخدمة سيارات السفر والملاكي والنقل.", "تأمين فوري للأعطال على طريقي السويس - القاهرة والسويس - السخنة الساحلي."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في ميدان الأربعين أو بورتوفيق بالسويس؟",
            "a": "أقل من 15 دقيقة لتواجد سياراتنا الدائم بقلب مدينة السويس."
      }
,
      {
        "q": "هل تخدمون محيط قناة السويس ومناطق الموانئ؟",
        "a": "نعم، السويس وبور توفيق وميناء السويس وطريق أبو سلطان مغطاة بخدمة الإنقاذ والنقل الكاملة."
      }],
    nearby: ["نفق أحمد حمدي", "العين السخنة", "طريق السويس", "الإسماعيلية", "بورتوفيق"]
  },

  "الإسماعيلية": {
    tier: 1,
    title: "ونش انقاذ الإسماعيلية",
    metaDescription: "ونش انقاذ الإسماعيلية: نمرة 6، بحيرة التمساح، جامعة قناة السويس، شارع محمد علي، طريق البلاجات، نفق 30 يونيو. وصول 10-15 دقيقة - 01044844492.",
    intro: "مدينة الإسماعيلية عروس القناة وواحة الحدائق الساحرة. نوفر أوناش إنقاذ متمركزة في منطقة نمرة 6 وكورنيش بحيرة التمساح وطريق البلاجات ومحيط جامعة قناة السويس لإنقاذ فوري لكافة المركبات طوال 24 ساعة.",
    responseTime: "10–15 دقيقة في الإسماعيلية",
    landmarks: ["منطقة نمرة 6 ومعديات قناة السويس", "كورنيش وشواطئ بحيرة التمساح", "جامعة قناة السويس والمستشفى الجامعي", "نادي الفيروز ونادي الدنفاة", "نفق تحيا مصر بالإسماعيلية", "ميدان الممر التجاري"],
    streets: ["شارع محمد علي (الإسماعيلية)", "طريق البلاجات السياحي", "طريق القاهرة - الإسماعيلية الصحراوي", "طريق الإسماعيلية - بورسعيد", "شارع شبين الكوم الإسماعيلية", "محور فؤاد عزيز غالي"],
    localNotes: ["أوناش متواجدة عند بوابات نفق تحيا مصر ومعدية نمرة 6 لسرعة العبور لسيناء أو القاهرة.", "سحب آمن وسريع للمركبات ونقلها لمراكز صيانة الإسماعيلية أو القاهرة بأفضل الأسعار."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في نمرة 6 أو طريق البلاجات بالإسماعيلية؟",
            "a": "يصل الونش خلال أقل من 15 دقيقة لتمركز أوناشنا المباشر بقلب الإسماعيلية."
      }
,
      {
        "q": "ما تكلفة نقل سيارة من القاهرة إلى الإسماعيلية؟",
        "a": "من القاهرة إلى الإسماعيلية (120 كم) عبر طريق الإسماعيلية الصحراوي: 700-1200 ج.م. مسافة 90 دقيقة."
      }],
    nearby: ["طريق الإسماعيلية", "بورسعيد", "السويس", "العاشر من رمضان", "الشرقية", "محور 30 يونيو"]
  },

  "الفيوم": {
    tier: 1,
    title: "ونش انقاذ الفيوم وبحيرة قارون",
    metaDescription: "ونش انقاذ الفيوم: السواقي، وادي الحيتان، بحيرة قارون، تونس، جامعة الفيوم، طريق الفيوم القاهرة. وصول 15-20 دقيقة بخصم 50% - 01044844492.",
    intro: "محافظة الفيوم واحة الطبيعة الساحرة وأقرب محافظات الصعيد للقاهرة الكبرى. أوناش إنقاذ محمد بحر متمركزة في مدينة الفيوم وعلى طريق بحيرة قارون وطريق القاهرة - الفيوم الصحراوي لإنقاذ وسحب سيارات الملاكي والدفع الرباعي على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة في الفيوم",
    landmarks: ["سواقي الفيوم الشهيرة بميدان القارون", "بحيرة قارون والقرى السياحية", "قرية تونس السياحية", "وادي الريان ووادي الحيتان", "جامعة الفيوم والمستشفى الجامعي", "بوابة رسوم طريق الفيوم الصحراوي"],
    streets: ["طريق القاهرة - الفيوم الصحراوي", "طريق بحيرة قارون السياحي", "شارع جمال عبد الناصر الفيوم", "شارع أحمد شوقي الفيوم", "طريق أسيوط الغربي (مدخل الفيوم)"],
    localNotes: ["أوناش مجهزة للتعامل مع الطبيعة الصحراوية والطرق السياحية بقرية تونس ووادي الريان.", "تغطية فورية لأعطال طريق القاهرة - الفيوم الصحراوي وطريق أسيوط الغربي."],
    faqs: [
      {
            "q": "هل تغطون بحيرة قارون وقرية تونس السياحية بالفيوم؟",
            "a": "نعم، أوناشنا متواجدة على طريق بحيرة قارون وتغطي قرية تونس ووادي الريان بالكامل."
      }
,
      {
        "q": "ما أسرع خدمة إنقاذ متاحة في الفيوم؟",
        "a": "من موقعنا في القاهرة نصل للفيوم في 60-90 دقيقة. للطوارئ على طريق الفيوم قبل المدينة: 40-60 دقيقة."
      }],
    nearby: ["طريق الفيوم", "حدائق الأهرام", "بني سويف", "الجيزة", "6 أكتوبر"]
  },

  "طريق الفيوم": {
    tier: 1,
    title: "ونش انقاذ طريق مصر الفيوم الصحراوي",
    metaDescription: "ونش انقاذ طريق الفيوم: من ميدان الرماية وبوابات حدائق الأهرام وحدائق أكتوبر حتى بوابات الفيوم وكوم أوشيم. وصول 15 دقيقة - 01044844492.",
    intro: "شريان الفيوم الصحراوي السريع الواصل بين هضبة الأهرام وميدان الرماية حتى بحيرة قارون والمنطقة الصناعية بكوم أوشيم، أوناشنا متواجدة لتأمين المسافرين على مدار اليوم.",
    responseTime: "15 دقيقة على طريق الفيوم",
    landmarks: ["بوابة رسوم طريق الفيوم (كارتة الفيوم)", "ميدان الرماية (بداية طريق الفيوم)", "بوابات حدائق الأهرام وحدائق أكتوبر على طريق الفيوم", "المنطقة الصناعية بكوم أوشيم", "متحف كوم أوشيم الأثري"],
    streets: ["طريق القاهرة - الفيوم الصحراوي الحر", "طريق أسيوط الغربي", "طريق الواحات (تقاطع طريق الفيوم)", "طريق دهشور"],
    localNotes: ["معدات سحب دفع رباعي مخصصة للرمال والمنحدرات الصحراوية بمحيط بحيرة قارون وكوم أوشيم.", "تأمين فوري لمركبات النقل والملاكي عند تقاطعات حدائق الأهرام وأكتوبر."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ على طريق الفيوم عند كارتة الرسوم أو كوم أوشيم؟",
            "a": "من 10 إلى 15 دقيقة فقط لتمركز أوناشنا المباشر على طريق الفيوم الصحراوي."
      }
,
      {
        "q": "ما أبرز مواقع الخطر على طريق الفيوم؟",
        "a": "المنعطفات عند عزبة الورد وكيلو 80 ومدخل الفيوم من أكثر المواقع التي نتلقى نداءات الإنقاذ منها على الطريق."
      }],
    nearby: ["الفيوم", "حدائق الأهرام", "حدائق أكتوبر", "طريق الواحات", "6 أكتوبر"]
  },

  "بني سويف": {
    tier: 1,
    title: "ونش انقاذ بني سويف",
    metaDescription: "ونش انقاذ بني سويف: كورنيش النيل، جامعة بني سويف، كوبري النيل، شرق النيل، المنطقة الصناعية، طريق الكريمات. وصول 15-20 دقيقة - 01044844492.",
    intro: "محافظة بني سويف لؤلؤة الصعيد وبوابة الصعيد الشمالية. أوناش إنقاذ محمد بحر متمركزة في مدينة بني سويف وشرق النيل وعلى طريق الكريمات وطريق الصعيد الحر لإنقاذ وسحب سيارات الملاكي والنقل على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة في بني سويف",
    landmarks: ["جامعة بني سويف ومستشفاها التخصصي", "كورنيش النيل الجديد ببني سويف", "كوبري بني سويف العلوي على النيل", "المنطقة الصناعية ببياض العرب (شرق النيل)", "محطة قطار بني سويف", "هرم ميدوم الأثري"],
    streets: ["طريق الصعيد الحر (طريق الجيش)", "طريق القاهرة - بني سويف الزراعي", "طريق الكريمات الصحراوي الشرقي", "شارع عبد السلام عارف بني سويف", "طريق كورنيش النيل بني سويف"],
    localNotes: ["أوناش متواجدة عند مطلع كوبري النيل والمنطقة الصناعية بشرق النيل لسرعة الاستجابة.", "تغطية فورية لأعطال وحوادث طريق الكريمات الصحراوي الشرقي وطريق الصعيد الحر."],
    faqs: [
      {
            "q": "هل تغطون طريق الكريمات والمنطقة الصناعية بشرق النيل ببني سويف؟",
            "a": "نعم، أوناشنا متواجدة على طريقي الكريمات والصعيد الحر وشرق النيل 24/7."
      }
,
      {
        "q": "ما زمن الوصول من القاهرة إلى بني سويف؟",
        "a": "من القاهرة إلى بني سويف: 60-90 دقيقة عبر طريق الصعيد الصحراوي. للطوارئ على الطريق: أرسل موقعك فوراً."
      }],
    nearby: ["المنيا", "الفيوم", "حلوان", "طريق الكريمات", "الصعيد"]
  },

  "المنيا": {
    tier: 1,
    title: "ونش انقاذ المنيا عروس الصعيد",
    metaDescription: "ونش انقاذ المنيا: كورنيش النيل، جامعة المنيا، المنيا الجديدة، كوبري النيل، ملوي، سمالوط، طريق الصعيد الصحراوي. وصول 15-20 دقيقة - 01044844492.",
    intro: "محافظة المنيا عروس الصعيد وقلب مصر الوسطى. نوفر أوناش إنقاذ متمركزة في مدينة المنيا والمنيا الجديدة وعلى طريقي الصعيد الصحراوي الشرقي والغربي لإنقاذ فوري للمسافرين وسيارات الأهالي طوال 24 ساعة.",
    responseTime: "15–20 دقيقة في المنيا",
    landmarks: ["كورنيش النيل بالمنيا (أطول كورنيش بالصعيد)", "جامعة المنيا والمستشفى الجامعي", "مدينة المنيا الجديدة", "كوبري المنيا العلوي على النيل", "منطقة تل العمارنة وتونة الجبل", "دير السيدة العذراء بجبل الطير بسمالوط"],
    streets: ["طريق الصعيد الصحراوي الشرقي (الجيش)", "طريق الصعيد الصحراوي الغربي", "طريق مصر أسوان الزراعي (قطاع المنيا)", "شارع كورنيش النيل المنيا", "شارع طه حسين المنيا"],
    localNotes: ["أوناش مجهزة للتعامل مع المسافات الطويلة والسرعات العالية على طريقي الصعيد الصحراوي الشرقي والغربي.", "توفير خدمات سحب فورية ورفع آمن للمركبات المعطلة أو المتضررة من الحوادث."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ على طريق الصعيد الصحراوي الشرقي نطاق المنيا؟",
            "a": "من 15 إلى 20 دقيقة لتمركز أوناشنا الدائم عند مداخل المنيا وسمالوط وملوي."
      }
,
      {
        "q": "هل تخدمون المنيا والمناطق الأثرية بالقرب منها؟",
        "a": "نعم، نقل من القاهرة إلى المنيا (245 كم): 1500-2500 ج.م. يستغرق 3-3.5 ساعات قيادة."
      }],
    nearby: ["بني سويف", "أسيوط", "ملوي", "سمالوط", "المنيا الجديدة"]
  },

  "أسيوط": {
    tier: 1,
    title: "ونش انقاذ أسيوط عاصمة الصعيد",
    metaDescription: "ونش انقاذ أسيوط: جامعة أسيوط، جامعة الأزهر، أسيوط الجديدة، قناطر أسيوط الجديدة، كوبري النيل، شارع يسري راغب. وصول 15 دقيقة - 01044844492.",
    intro: "قلب الصعيد النابض، خدمة إنقاذ سيارات احترافية بجوار قناطر أسيوط والهضبة الغربية والمستشفيات الجامعية الكبرى بأسيوط على مدار 24 ساعة.",
    responseTime: "15 دقيقة في أسيوط",
    landmarks: ["جامعة أسيوط والمستشفيات الجامعية الكبرى", "جامعة الأزهر فرع أسيوط", "قناطر أسيوط الجديدة وهويس النيل", "مدينة أسيوط الجديدة", "دير العذراء بجبل درنكة", "ميدان المحطة بأسيوط"],
    streets: ["شارع الجمهورية أسيوط", "شارع يسري راغب التجاري", "طريق الصعيد الصحراوي الشرقي والغربي", "طريق أسيوط - القاهرة الزراعي", "طريق كورنيش النيل أسيوط", "شارع الهلالي"],
    localNotes: ["سطحات هيدروليكية مجهزة لمسارات الصعيد الصحراوية والزراعية ونقل السيارات للقاهرة.", "تمركز سريع عند محيط جامعة أسيوط وقناطر أسيوط لنجدة سيارات الأعطال والحوادث."],
    faqs: [
      {
            "q": "هل تغطون مدينة أسيوط الجديدة ودير درنكة؟",
            "a": "نعم، أوناشنا متواجدة بأسيوط الجديدة ودرنكة وكافة مراكز أسيوط على مدار 24 ساعة."
      }
,
      {
        "q": "ما تكلفة نقل سيارة من القاهرة إلى أسيوط؟",
        "a": "النقل من القاهرة إلى أسيوط (400 كم): 2000-3000 ج.م حسب نوع السيارة. يستغرق 4-5 ساعات قيادة."
      }],
    nearby: ["سوهاج", "المنيا", "أسيوط الجديدة", "منفلوط", "ديروط", "أبنوب"]
  },

  "سوهاج": {
    tier: 1,
    title: "ونش انقاذ سوهاج وسوهاج الجديدة",
    metaDescription: "ونش انقاذ سوهاج: كورنيش النيل، جامعة سوهاج، سوهاج الجديدة (الكوامل)، كوبري أخميم، طهطا، جرجا. وصول 15-20 دقيقة بخصم 50% - 01044844492.",
    intro: "محافظة سوهاج قلب الصعيد التاريخي والصناعي. نوفر أوناش إنقاذ متمركزة عند كوبري أخميم وكورنيش النيل وجامعة سوهاج بمقر الكوامل وطريق الصعيد الحر لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة في سوهاج",
    landmarks: ["جامعة سوهاج بمقر الكوامل الجديد", "كوبري أخميم العلوي على النيل", "متحف سوهاج القومي على الكورنيش", "مدينة سوهاج الجديدة", "معبد سيتي الأول بأبيدوس بالبلينا", "الدير الأبيض والدير الأحمر"],
    streets: ["شارع كورنيش النيل الشرقي والغربي بسوهاج", "شارع 15 بيسوهاج", "طريق الصعيد الصحراوي الشرقي والغربي", "طريق سوهاج - البحر الأحمر (سفاجا)", "شارع أسيوط سوهاج"],
    localNotes: ["أوناش مجهزة لخدمة طريق سوهاج - سفاجا (البحر الأحمر) وطريقي الصعيد الصحراوي.", "توفير خدمات سحب فورية ورفع آمن للمركبات المتعطلة أو المتضررة من الحوادث."],
    faqs: [
      {
            "q": "هل تغطون طريق سوهاج - البحر الأحمر وجامعة سوهاج بالكوامل؟",
            "a": "نعم، أوناشنا متواجدة بالكوامل وعلى طريق سوهاج - سفاجا 24/7."
      }
,
      {
        "q": "هل تستطيعون نقل سيارة من القاهرة إلى سوهاج بأمان؟",
        "a": "نعم، نقل سيارة من القاهرة إلى سوهاج (450 كم) متاح: 2500-3500 ج.م بأوناش مغطاة وسائقين ذوي خبرة."
      }],
    nearby: ["أسيوط", "قنا", "أخميم", "طهطا", "جرجا", "سوهاج الجديدة"]
  },

  "قنا": {
    tier: 1,
    title: "ونش انقاذ قنا وقنا الجديدة",
    metaDescription: "ونش انقاذ قنا: جامعة جنوب الوادي، معبد دندرة، كوبري دندرة، كورنيش النيل، نجع حمادي، قفط، طريق سفاجا. وصول 15-20 دقيقة - 01044844492.",
    intro: "محافظة قنا وملتقى طرق الصعيد والبحر الأحمر. أوناش إنقاذ محمد بحر متمركزة أمام جامعة جنوب الوادي وكوبري دندرة وعلى طريق قنا - سفاجا لتقديم خدمة سحب ورفع سيارات سريعة وآمنة 24 ساعة.",
    responseTime: "15–20 دقيقة في قنا",
    landmarks: ["جامعة جنوب الوادي بقنا", "معبد دندرة التاريخي", "كوبري دندرة العلوي على النيل", "مدينة قنا الجديدة", "ميدان سيدي عبد الرحيم القنائي", "مدينة نجع حمادي ومجمع الألومنيوم"],
    streets: ["شارع 23 يوليو بقنا", "شارع كورنيش النيل قنا", "طريق قنا - سفاجا (البحر الأحمر)", "طريق الصعيد الصحراوي الشرقي والغربي", "طريق قنا - الأقصر الزراعي"],
    localNotes: ["أوناش متواجدة عند مخرج طريق قنا - سفاجا لخدمة سيارات السفر المتجهة للبحر الأحمر.", "سحب آمن وسريع للمركبات ونقلها لمراكز صيانة قنا أو الأقصر."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام جامعة جنوب الوادي أو معبد دندرة بقنا؟",
            "a": "يصل الونش خلال أقل من 20 دقيقة لتواجد سياراتنا الدائم بقلب قنا."
      }
,
      {
        "q": "ما تكلفة نقل سيارة من القاهرة إلى قنا؟",
        "a": "نقل من القاهرة إلى قنا (530 كم): 3000-4000 ج.م. مسافة تستغرق 5-6 ساعات بسائقين متخصصين في رحلات الصعيد."
      }],
    nearby: ["الأقصر", "سوهاج", "دندرة", "نجع حمادي", "قوص", "سفاجا"]
  },

  "الأقصر": {
    tier: 1,
    title: "ونش انقاذ الأقصر",
    metaDescription: "ونش انقاذ الأقصر: معبد الكرنك، معبد الأقصر، وادي الملوك بالبر الغربي، كورنيش النيل، مطار الأقصر الدولي. وصول 15 دقيقة - 01044844492.",
    intro: "مدينة الأقصر عاصمة السياحة والآثار العالمية التي تضم ثلث آثار العالم. نوفر أوناش إنقاذ متخصصة في البر الشرقي والبر الغربي لخدمة الأفواج السياحية والسيارات الملاكي وسيارات الفنادق طوال 24 ساعة.",
    responseTime: "15 دقيقة في الأقصر",
    landmarks: ["معبد الكرنك العظيم", "معبد الأقصر وطريق الكباش", "وادي الملوك ووادي الملكات بالبر الغربي", "مطار الأقصر الدولي", "معبد حتشبسوت بالدير البحري", "فندق ونتر بالاس التاريخي"],
    streets: ["شارع كورنيش النيل بالأقصر", "شارع خالد بن الوليد الأقصر", "شارع المحطة الأقصر", "طريق المطار الأقصر", "طريق الأقصر - أسوان الزراعي والصحراوي", "طريق البر الغربي السياحي"],
    localNotes: ["أوناش هيدروليكية كاملة السطحة لنقل الحافلات السياحية الصغيرة وسيارات الليموزين والسيارات الفارهة.", "تغطية فورية للبر الشرقي والبر الغربي ومحيط مطار الأقصر الدولي."],
    faqs: [
      {
            "q": "هل تغطون البر الغربي ووادي الملوك ومعبد حتشبسوت بالأقصر؟",
            "a": "نعم، أوناشنا متواجدة بالبر الغربي والبر الشرقي على مدار 24 ساعة."
      }
,
      {
        "q": "هل تنقلون السيارات من القاهرة إلى الأقصر للسياح؟",
        "a": "نعم، نقدم خدمة نقل سيارات السياح من القاهرة إلى الأقصر (670 كم): 4000-5000 ج.م. الحجز المسبق مطلوب."
      }],
    nearby: ["قنا", "أسوان", "إسنا", "أرمنت", "طريق البحر الأحمر"]
  },

  "أسوان": {
    tier: 1,
    title: "ونش انقاذ أسوان وبوابة الجنوب",
    metaDescription: "ونش انقاذ أسوان: السد العالي، خزان أسوان، معبد فيلة، كورنيش النيل، مطار أسوان الدولي، كوم أمبو، إدفو. وصول 15-20 دقيقة - 01044844492.",
    intro: "محافظة أسوان لؤلؤة النيل والدرة الجنوبية لجمهورية مصر العربية. أوناش إنقاذ محمد بحر متمركزة في مدينة أسوان وعند السد العالي ومعبد فيلة وعلى طريقي الصحراوي الغربي لإنقاذ وسحب سيارات الملاكي والسياحة 24/7.",
    responseTime: "15–20 دقيقة في أسوان",
    landmarks: ["السد العالي وبحيرة ناصر", "خزان أسوان التاريخي", "معبد فيلة بجزيرة أجيليكا", "مطار أسوان الدولي", "رمز الصداقة المصرية السوفيتية", "متحف النوبة وحديقة النباتات", "معبد كوم أمبو ومعبد إدفو"],
    streets: ["شارع كورنيش النيل أسوان", "شارع أبطال التحرير أسوان", "طريق السادات أسوان", "طريق خزان أسوان", "طريق أسوان - القاهرة الصحراوي الغربي", "طريق أسوان - أبو سمبل الدولي"],
    localNotes: ["أوناش مجهزة للمسافات المفتوحة وطريق أبو سمبل الدولي والحدود الجنوبية.", "توفير خدمات سحب فورية ورفع آمن للسيارات السياحية وسيارات الأهالي."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ عند السد العالي أو كورنيش أسوان؟",
            "a": "يصل الونش خلال 15 إلى 20 دقيقة لتواجد سياراتنا الدائم بقلب أسوان وخزان أسوان."
      }
,
      {
        "q": "ما أبعد موقع يمكنكم الوصول إليه عبر طريق الصعيد؟",
        "a": "أسوان هي أبعد نقطة في طريق الصعيد التي نغطيها (900 كم من القاهرة). تكلفة النقل: 5000-7000 ج.م."
      }],
    nearby: ["الأقصر", "كوم أمبو", "إدفو", "أبو سمبل", "دراو"]
  },

  "شرم الشيخ": {
    tier: 1,
    title: "ونش انقاذ شرم الشيخ وجنوب سيناء",
    metaDescription: "ونش انقاذ شرم الشيخ: خليج نعمة، سوهو سكوير، نبق، الهضبة، مطار شرم الشيخ، رأس محمد، دهب. وصول 15-20 دقيقة بخصم 50% - 01044844492.",
    intro: "مدينة شرم الشيخ مدينة السلام العالمية وأيقونة السياحة الشاطئية في البحر الأحمر. ننشر أسطول أوناش سطحة هيدروليكية كاملة في خليج نعمة وسوهو سكوير وخليج نبق ورأس محمد لخدمة النزلاء والسيارات الفارهة والسياحية طوال 24 ساعة.",
    responseTime: "15–20 دقيقة في شرم الشيخ",
    landmarks: ["خليج نعمة Naama Bay", "سوهو سكوير Soho Square", "منطقة خليج نبق المحمية", "هضبة أم السيد والشاطئ القديم", "مطار شرم الشيخ الدولي", "محمية رأس محمد العالمية", "مسجد الصحابة بالسوق القديم"],
    streets: ["طريق السلام السياحي", "طريق الشيخ زايد (الدائري الأوسطي بشرم)", "شارع خليج نعمة الرئيسي", "طريق شرم الشيخ - الطور - نفق أحمد حمدي الدولي", "طريق شرم الشيخ - دهب الساحلي"],
    localNotes: ["أوناش سطحة هيدروليكية حديثة لنقل السيارات الرياضية والفارهة بدون أي خدوش.", "إمكانية سحب ونقل السيارات من شرم الشيخ ودهب إلى القاهرة أو السويس مباشرة."],
    faqs: [
      {
            "q": "هل توفرون خدمة سحب ونقل السيارات من شرم الشيخ إلى القاهرة؟",
            "a": "نعم، نوفر أوناش سطحة مؤمنة لنقل سيارتك من أي منتجع بشرم الشيخ ودهب إلى منزلك بالقاهرة بأمان تام."
      }
,
      {
        "q": "هل تنقلون السيارات من القاهرة إلى شرم الشيخ؟",
        "a": "نعم، نقل من القاهرة إلى شرم الشيخ (530 كم) عبر نفق السويس: 3000-4500 ج.م. الحجز المسبق ضروري."
      }],
    nearby: ["دهب", "نويبع", "طابا", "رأس سدر", "طور سيناء", "نفق أحمد حمدي"]
  },

  "طابا": {
    tier: 2,
    title: "ونش انقاذ طابا وخليج العقبة",
    metaDescription: "ونش انقاذ طابا: قلعة صلاح الدين بجزيرة فرعون، طابا هايتس، منفذ طابا، فيورد باي، طريق نويبع. وصول 20-30 دقيقة - 01044844492.",
    intro: "مدينة طابا البوابة الشرقية لسيناء على خليج العقبة. نوفر أوناش إنقاذ متخصصة لخدمة منتجعات طابا هايتس، خليج فيورد، قلعة جزيرة فرعون، ومنفذ طابا البري على مدار 24 ساعة.",
    responseTime: "20–30 دقيقة في طابا",
    landmarks: ["منتجع طابا هايتس Taba Heights", "قلعة صلاح الدين بجزيرة فرعون", "خليج فيورد Fiord Bay", "منفذ طابا البري والحدودي", "مطار طابا الدولي"],
    streets: ["طريق طابا - نويبع الساحلي الدولي", "طريق طابا - النقب - السويس", "طريق طابا هايتس الداخلي"],
    localNotes: ["أوناش مجهزة للتعامل مع المنحدرات الجبلية على خليج العقبة وسحب السيارات بأمان.", "جاهزية كاملة لخدمة سيارات السياحة والنزلاء بالمنتجعات الدولية."],
    faqs: [
      {
            "q": "هل تغطون طابا هايتس وخليج فيورد بطابا؟",
            "a": "نعم، نغطي طابا هايتس وفيورد باي وكافة منتجعات طابا 24/7."
      }
,
      {
        "q": "هل تنقلون السيارات من القاهرة إلى طابا في سيناء؟",
        "a": "نعم، نقل من القاهرة إلى طابا (530 كم) عبر نفق أحمد حمدي وسيناء: 3000-4500 ج.م. الحجز المسبق إلزامي."
      }],
    nearby: ["نويبع", "دهب", "شرم الشيخ", "سانت كاترين"]
  },

  "نويبع": {
    tier: 2,
    title: "ونش انقاذ نويبع وميناء نويبع",
    metaDescription: "ونش انقاذ نويبع: ميناء نويبع البحري، الترابين، رأس شيطان، الكامبات السياحية، طريق دهب وطابا. وصول 20-30 دقيقة - 01044844492.",
    intro: "مدينة نويبع وميناء نويبع البحري على خليج العقبة، مركز الكامبات السياحية البيئية في رأس شيطان والترابين. نوفر أوناش إنقاذ متواجدة لخدمة الشاحنات وسيارات الركاب والسياح طوال 24 ساعة.",
    responseTime: "20–30 دقيقة في نويبع",
    landmarks: ["ميناء نويبع البحري (العبارات)", "منطقة رأس شيطان السياحية", "شاطئ ومخيمات الترابين", "وادي الوشواشي الأثري", "قلعة نويبع التاريخية"],
    streets: ["طريق نويبع - طابا الساحلي", "طريق نويبع - دهب الدولي", "طريق نويبع - سانت كاترين", "طريق ميناء نويبع"],
    localNotes: ["أوناش متواجدة بالقرب من ميناء نويبع لخدمة السيارات والشاحنات العابرة للخليج.", "تغطية لكافة كامبات رأس شيطان وطريق الساحل الصخري."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند ميناء نويبع وكامبات رأس شيطان؟",
            "a": "نعم، أوناشنا تغطي ميناء نويبع ورأس شيطان على مدار 24 ساعة."
      }
,
      {
        "q": "ما تكلفة نقل سيارة من القاهرة إلى نويبع عبر نفق السويس؟",
        "a": "نقل من القاهرة إلى نويبع (480 كم) عبر النفق وطريق شرم الشيخ: 2800-4000 ج.م. مسافة 5-6 ساعات."
      }],
    nearby: ["طابا", "دهب", "شرم الشيخ", "سانت كاترين"]
  },

  "المنيل": {
    tier: 1,
    title: "ونش انقاذ المنيل",
    metaDescription: "ونش انقاذ المنيل: قصر المانسترلي، متحف قصر المنيل، مستشفى قصر العيني، كوبري الجامعة، شارع عبد العزيز آل سعود. وصول 5-10 دقائق - 01044844492.",
    intro: "ونش إنقاذ المنيل وجزيرة الروضة وكوبري الجامعة وقصر العيني؛ أوناش شوكة مدمجة تصلك خلال 5 إلى 10 دقائق لإنقاذ سيارتك على ضفاف النيل بأمان تام.",
    responseTime: "5–10 دقائق في المنيل",
    landmarks: ["متحف قصر المنيل (الأمير محمد علي)", "قصر المانسترلي ومقياس النيل التاريخي", "مستشفى قصر العيني التعليمي الجديد", "كوبري الجامعة وكوبري الجيزة (عباس)", "حديقة الأندلس النيلية بالمنيل"],
    streets: ["شارع عبد العزيز آل سعود (كورنيش المنيل)", "شارع المنيل الرئيسي", "شارع متحف المنيل", "شارع المقياس", "شارع الملك المظفر"],
    localNotes: ["أوناش شوكة مدمجة مصممة خصيصاً للالتفاف والمناورة في شوارع المنيل النيلية وأزقته السكنية الضيقة.", "إخلاء سريع للأعطال بمحيط مستشفيات قصر العيني وكوبري الجامعة لتفادي شل حركة المرور الحيوية.", "قرب المسافة لنقل السيارة لمراكز صيانة الدقي والجيزة أو وسط البلد في دقائق معدودة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في شارع المنيل الرئيسي؟",
            "a": "نصلك خلال 5 إلى 10 دقائق لتمركزنا المباشر بالقرب من كوبري الجامعة وميدان السرايا."
      },
      {
            "q": "هل تسحبون السيارات المعطلة أمام مستشفى قصر العيني؟",
            "a": "نعم، نتدخل فوراً لإخلاء محيط المستشفى ونقل السيارة بأمان تام دون إعاقة سيارات الإسعاف."
      }
],
    nearby: ["السيدة زينب", "وسط البلد", "الدقي", "الجيزة", "قصر العيني", "مصر القديمة"]
  },

  "منيل الروضة": {
    tier: 2,
    title: "ونش انقاذ المنيل ومنيل الروضة",
    metaDescription: "ونش انقاذ المنيل: قصر المانسترلي، متحف قصر المنيل، مستشفى قصر العيني، كوبري الجامعة، شارع عبد العزيز آل سعود. وصول 5-10 دقائق - 01044844492.",
    intro: "جزيرة الروضة وحي المنيل الراقي بقلب نيل القاهرة. نوفر أوناش إنقاذ متمركزة في شارع عبد العزيز آل سعود ومحيط قصر المانسترلي ومتحف المنيل لإنقاذ فوري وسريع على مدار 24 ساعة.",
    responseTime: "5–10 دقائق في المنيل",
    landmarks: ["متحف قصر المنيل (الأمير محمد علي)", "قصر المانسترلي ومقياس النيل التاريخي", "مستشفى قصر العيني التعليمي الجديد", "كوبري الجامعة وكوبري الجيزة (عباس)", "حديقة الأندلس النيلية بالمنيل"],
    streets: ["شارع عبد العزيز آل سعود (كورنيش المنيل)", "شارع المنيل الرئيسي", "شارع متحف المنيل", "شارع المقياس", "شارع الملك المظفر"],
    localNotes: ["أوناش مدمجة متخصصة للتحرك السريع بشوارع المنيل الهادئة ومحيط كباري النيل.", "توفير خدمات الطوارئ للبطاريات وتغيير الإطارات وتزويد الوقود في الموقع."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ في شارع عبد العزيز آل سعود بالمنيل؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجدنا الدائم على كورنيش المنيل."
      }
,
      {
        "q": "هل تخدمون جزيرة منيل الروضة والكورنيش المحيط بها؟",
        "a": "نعم، منيل الروضة وكورنيشها ومنطقة المنيرة وجسر القاهرة مغطاة بخدمتنا الكاملة."
      }],
    nearby: ["السيدة زينب", "وسط البلد", "الدقي", "الجيزة", "قصر العيني", "مصر القديمة"]
  }
};
